import { SetupCall } from '@driscollsinc/driscolls-display-rules';
import { LOOKUP_FIELDS } from '../constants';
import { lookupSetupFields } from './CommonSetupFields';

function configureSetupCall() {
    SetupCall(
        LOOKUP_FIELDS.CommodityOffsetWeekLookUp,
        [...lookupSetupFields],
        {}, //options
        (data) => {
            console.log('CommodityOffsetWeekLookUp REDUCER-- ', data);
        }
    );
}

const CommodityOffsetWeekLookUp = {
    configureSetupCall
};

export default CommodityOffsetWeekLookUp;
